import { routes } from "../../../routes/mainRoutes";

const initialLoginValues = {
  email: '',
  password: '',
};

const initialRegisterValues = {
  email: '',
  password: '',
  confirmPassword: '',
};

const initialSendEmailValues = {
  sendEmail: '',
};

const initialResetPasswordValues = {
  newPassword: '',
  newConfirm: '',
};

const getInitialValues = matchUrl => {
  switch (matchUrl) {
    case routes.LOGIN:
      return initialLoginValues;
    case routes.REGISTER:
      return initialRegisterValues;
    case routes.SEND_EMAIL:
      return initialSendEmailValues;
    case routes.RESET_PASSWORD:
      return initialResetPasswordValues;
    default:
      return '/';
  }
};

export { getInitialValues };
